import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Ga4AccountVM } from 'src/app/models/ga4-account-vm';

@Component({
  selector: 'app-ga4',
  templateUrl: './ga4.component.html',
  styleUrls: ['./ga4.component.scss']
})
export class Ga4Component {
  isMobile = false;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  @Input() ga4Accounts: Ga4AccountVM[] = [];
  @Input() visible = false;
  @Input() loading = false;
  @Input() isSavingDimensions = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() addGa4Account = new EventEmitter<void>();
  @Output() removeGa4AccountEvent = new EventEmitter<Ga4AccountVM>();
  @Output() close = new EventEmitter<void>();

  @Output() saveProperties = new EventEmitter<{ uid: string, properties: string[] }>();
  @Output() saveDimensions = new EventEmitter<{ uid: string, allProperties: any[], selectedPropertyIds: string[] }>();

  constructor(
    private confirmationService: ConfirmationService
  ){

  }

  onAddGa4Account(): void {
    this.addGa4Account.emit();
  }

  onRemoveGa4Account(account: Ga4AccountVM): void {
    this.removeGa4AccountEvent.emit(account);
  }

  trackByUid = (_: number, a: Ga4AccountVM) => a.uid;
  getTotalProperties(): number {
    return (this.ga4Accounts || []).reduce((acc, acct) => acc + (acct.properties?.length || 0), 0);
  }

  onSelectedPropertiesChange(acct: Ga4AccountVM) {
    // Dispara o evento para o componente pai, levando o uid e as propriedades selecionadas
    this.saveProperties.emit({
      uid: acct.uid,
      properties: acct.selectedProperties ?? []
    });
  }


  onOpenGoogleAnalytics() {
    this.confirmationService.confirm({
      message: 'Você será direcionado para a página do Google Analytics 4 para criar uma nova propriedade. Deseja continuar?',
      header: 'Redirecionar para o Google Analytics 4',
      icon: 'pi pi-external-link',
      acceptLabel: 'Ir para o Google',
      rejectLabel: 'Cancelar',
      accept: () => {
        window.open('https://analytics.google.com/analytics/web/', '_blank');
      }
    });
  }

  onSaveDimensions(acct: Ga4AccountVM) {
    this.saveDimensions.emit({
      uid: acct.uid,
      allProperties: acct.properties || [],
      selectedPropertyIds: acct.selectedProperties || []
    });
  }
}
